import React, { useCallback, useEffect, useState } from "react";
import DefaultButton from "../../components/buttons/defaultButton";
import PageTableHeader from "../../components/pageTableHeader/pageTableHeader";
import { DefaultSelectFilter } from "../../components/inputs/defaultSelectFilter";
import { VscBell } from "react-icons/vsc";
import { getNotificaionList } from "../../../services/workspace/global.service";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { _categorizeByDate } from "../../../utils/common";
import moment from "moment";
import ListSkeleton from "../../components/skeleton/listSheleton";

const breadcrumbs = [
  { label: "Home", path: "/" },
  { label: "Notification", path: "" },
];

const Alerts = () => {
  const { limit } = useSelector((state) => state.global);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchMore, setfetchMore] = useState(false);

  const fetchData = useCallback(() => {
    if (currentPage == 0 || !fetchMore) {
      setLoading(true);
    }
    getNotificaionList({ search: "", page: currentPage, limit })
      .then((response) => {
        // API returns { message, notification: { data: [], meta: { total, ... } } }
        const responseData = response?.notification?.data || response?.data || [];
        const responseTotal = response?.notification?.meta?.total ?? response?.meta?.total ?? response?.total ?? 0;

        setTableData(prevTableData => {
          const combinedData = currentPage === 1 ? [...responseData] : [...prevTableData, ...responseData];
          return combinedData;
        });
        setTotalData(responseTotal);
      })
      .catch((error) => {
        toast.error("Failed to fetch notification data!");
        console.error("Error fetching data: ", error);
        // Reset data on error to prevent undefined state
        setTableData([]);
        setTotalData(0);
      }).finally(() => {
        setLoading(false);
        setfetchMore(false)
      })
  }, [currentPage, limit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const fetchMoreData = () => {
    if (totalData == tableData?.length) return
    setfetchMore(true);
    setCurrentPage((prev) => prev + 1)
  }

  const handleMarkAllAsRead = () => {

  }
  const handleSelectChange = (e) => {
  };

  return (
    <div className="flex flex-col gap-2 p-4">
      <PageTableHeader
        breadcrumbs={breadcrumbs}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />
      <div className="flex flex-col gap-4 p-4 bg-white">
        {loading ? (
          <ListSkeleton />
        ) : tableData?.length > 0 ? (
          <>
            {/* <div className="flex md:justify-between md:flex-row flex-col gap-2 justify-end">
              <div className="flex gap-2 justify-between text-theme font-bold items-center bg-white">
                <div className="flex flex-row gap-2">
                  <DefaultSelectFilter
                    className="bg-light hover:bg-bghoverlight px-2 rounded-md"
                    label="Sort By"
                    options={[
                      { label: "Newest First", value: "desc" },
                      { label: "Oldest First", value: "asc" },
                    ]}
                    onChange={handleSelectChange}
                  />
                  <DefaultSelectFilter
                    className="bg-light hover:bg-bghoverlight px-2 rounded-md"
                    options={[
                      { label: "All", value: "all" },
                      { label: "Unread", value: "unread" },
                    ]}
                    onChange={handleSelectChange}
                  />
                </div>
              </div>
              <div className="flex justify-end">
                <DefaultButton
                  variant="secondary"
                  name="Mark all as read"
                  onClick={handleMarkAllAsRead}
                />
              </div>
            </div> */}
            <div className="flex flex-col gap-4 bg-white">
              {_categorizeByDate(tableData).map((item, idx) => (
                <div key={item.category ?? idx} className="flex flex-col gap-1">
                  <p className="text-textLight">{item.category || "-"}</p>
                  <div className="flex flex-col gap-2">
                    {item.data.map((alert, index) => (
                      <AlertCard key={index} {...alert} />
                    ))}
                  </div>
                </div>
              ))}
              {totalData > tableData.length && (
                <div className="flexCenter">
                  <DefaultButton
                    loading={fetchMore}
                    disabled={fetchMore}
                    onClick={fetchMoreData}
                    name="Load More"
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 px-4">
            <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
              <VscBell className="w-10 h-10 text-gray-400" />
            </div>
            <h3 className="text-lg font-semibold text-gray-700 mb-1">No notifications yet</h3>
            <p className="text-sm text-gray-500 text-center max-w-xs">
              When you have notifications, they&apos;ll show up here.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const AlertCard = ({
  profilePic,
  message,
  title,
  created_by,
  created_at,
  is_read,
  thumb,
}) => (
  <div className="flex justify-between items-center bg-light hover:bg-bghoverlight cursor-pointer p-4 rounded-lg ">
    <div className="flex gap-2">
      <div className="w-10 h-10 rounded-full bg-bghoverlight relative flexCenter">
        {thumb ? (
          <img
            src={profilePic}
            alt="Profile"
            className="w-10 h-10 rounded-full object-cover"
          />
        ) : (
          <VscBell className="text-xl" />
        )}
        
      </div>
      <div>
        <h3 className="font-semibold text-theme">{title || "-"}</h3>
        <h3 className="text-sm text-primary-250">{message || "-"}</h3>
        <p className="text-textLight">
          {moment(created_at).format("DD-MM-YYYY")} | {moment(created_at).format("HH:MM:a")}
        </p>
        {/* <h3 className="font-semibold text-theme">Sender : {created_by?.name + " | " + created_by?.email || "-"}</h3> */}
      </div>
    </div>
  </div>
);

export default Alerts;
